export const PLOOMES_ATTACHMENT_CATEGORIES: Record<string, string> = {
    comprovante_pagamento: 'Comprovante de pagamento',
    nota_fiscal: 'Nota fiscal',
    boleto: 'Boleto',
    contrato: 'Contrato',
    foto_produto: 'Foto do produto',
    foto_local: 'Foto do local / instalação',
    documento: 'Documento',
    outro: 'Outro',
};

export type SidebarFilter =
    | { type: 'all' }
    | { type: 'receipts' }
    | { type: 'pending' }
    | { type: 'validated' }
    | { type: 'category'; category: string };

export const SIDEBAR_ITEMS: Array<{ filter: SidebarFilter; label: string; icon: string }> = [
    { filter: { type: 'all' }, label: 'Todos os arquivos', icon: 'all' },
    { filter: { type: 'receipts' }, label: 'Comprovantes', icon: 'receipt' },
    { filter: { type: 'pending' }, label: 'Pendentes', icon: 'pending' },
    { filter: { type: 'validated' }, label: 'Validados', icon: 'validated' },
];
